var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50.4 8.9c-1.8.8-3.8 1.3-5.8 1.6 2.1-1.2 3.7-3.2 4.4-5.6-2 1.2-4.1 2-6.4 2.5-1.8-2-4.5-3.2-7.4-3.2-5.6 0-10.1 4.5-10.1 10.1 0 .8.1 1.6.3 2.3C17 16.1 9.6 12.1 4.6 6c-.9 1.5-1.4 3.2-1.4 5.1 0 3.5 1.8 6.6 4.5 8.4-1.7-.1-3.2-.5-4.6-1.3v.1c0 4.9 3.5 9 8.1 9.9-.8.2-1.7.4-2.7.4-.7 0-1.3-.1-1.9-.2 1.3 4 5 6.9 9.4 7-3.5 2.7-7.8 4.3-12.6 4.3-.8 0-1.6 0-2.4-.1 4.5 2.9 9.8 4.5 15.5 4.5 18.6 0 28.8-15.4 28.8-28.8V14c2.1-1.3 3.8-3.1 5.1-5.1z"}));
}

SocialTwitter.defaultProps = {"fill":"currentColor","viewBox":"0 0 51.6 48.3"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
